// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yjlsi","buttons":"styles_buttons__18bLk"};